<template>
    <div class="communities pure-g">

        <h3 class="pure-u-1 sectionTitle">All Communities in Canada</h3>
        
        <div v-for="item in items" :key="item.title" class="item pure-u-1-2 pure-u-lg-1-8">
            <div class="itemWrapper">

                <a :href="item.links[0].url" target="_blank">
                    <div class="image itemImage" :style="'background-image:url('+ item.image +');'"></div>
                    <p class="itemTitle">{{ item.title }}</p>
                </a>

                <div class="itemLinks">

                    <a
                        v-for="link in item.links"
                        :key="link.type"
                        :href="link.url"
                        target="_blank"
                        class="icon"
                        :class="link.type"
                    >
                        <ion-icon v-if="link.type === 'website'" name="earth"></ion-icon>
                        <ion-icon v-else-if="link.type === 'facebook'" name="logo-facebook"></ion-icon>
                        <ion-icon v-else-if="link.type === 'instagram'" name="logo-instagram"></ion-icon>
                        <ion-icon v-else-if="link.type === 'youtube'" name="logo-youtube"></ion-icon>
                    </a>

                </div>
            </div>
        </div>
        <div class="item addItem pure-u-1-2 pure-u-lg-1-8">
            <a href="mailto:info@onemgl.com?subject=OneMgl - Community Add Request">
                <div class="itemWrapper">
                    <div>
                        <ion-icon name="add-circle"></ion-icon>
                        <p>Add New or <br>Update Request</p>
                    </div>
                </div>
            </a>
        </div>

    </div>
</template>

<script>
    export default {
        data(){
            return{
                items: [
                    {
                        title: 'Embassy of Mongolia to Canada',
                        image: 'https://images.prismic.io/vanmglcom/14db08f4-9749-48a9-9c9a-23a10efc5f3f_mfalogo.png?auto=compress,format',
                        links: [
                            {
                                type: 'website',
                                url: 'https://www.mongoliacanada.mn/'
                            },
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/MongoliaCanada/'
                            }
                        ]
                    },
                    {
                        title: 'Canada Mongolia Chamber of Commerce',
                        image: 'https://images.prismic.io/vanmglcom/6771364d-b6ec-4e28-9eb9-71af2bdbaf01_canada_mongolia_chamber.jpeg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/groups/canadamongoliachamber'
                            }
                        ]
                    },
                    {
                        title: 'CMECA - Association Mongolia Canada',
                        image: 'https://images.prismic.io/vanmglcom/1a0995e8-30b7-4c5e-b3da-bc9db1b7e347_logo.jpg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/MongolianCanadianAssociation'
                            }
                        ]
                    },
                    {
                        title: 'OneMgl - Mongolians in Canada',
                        image: 'https://images.prismic.io/vanmglcom/9e69f78b-8745-4ed2-927c-7ef368f40caa_121015585_161076802317459_1571058744175153775_o.png?auto=compress,format',
                        links: [
                            {
                                type: 'website',
                                url: 'https://www.onemgl.com/'
                            },
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/onemglcom'
                            },
                            {
                                type: 'instagram',
                                url: 'https://www.instagram.com/onemglcom/'
                            },
                            {
                                type: 'youtube',
                                url: 'https://www.youtube.com/channel/UCjyVpUoJtbVBYcOeC58qG3Q'
                            }
                        ]
                    },
                    {
                        title: 'BC Mongolian - Community',
                        image: 'https://images.prismic.io/vanmglcom/881e7868-49c5-4136-9810-f4251a9d72b4_bc_mongolian_community.jpg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/bcmongolian'
                            }
                        ]
                    },
                    {
                        title: 'Mongolians in Calgary - Community',
                        image: 'https://images.prismic.io/vanmglcom/19950415-bada-4936-837b-bfa2edd0ba79_mongolians_in_calgary.jpg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/groups/Moncal'
                            }
                        ]
                    },
                    {
                        title: 'Mongolians in Saskatoon - Community',
                        image: 'https://images.prismic.io/vanmglcom/691d6a0f-fb4f-4b68-8708-f0de49565ba6_mongolians_in_saskatoon.jpg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/groups/110602440584'
                            }
                        ]
                    },
                    {
                        title: 'Mongolians in Toronto - Community',
                        image: 'https://images.prismic.io/vanmglcom/dd882832-a6fb-42af-80b4-104e73f0e468_mongolians_in_toronto.jpg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/groups/gtamongols'
                            }
                        ]
                    },
                    {
                        title: 'Mongolians in Edmonton - Community',
                        image: 'https://images.prismic.io/vanmglcom/c1ee3d96-5e5a-4240-9439-3735f381e115_edmonton+logo.jpg?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/groups/251613921707627'
                            }
                        ]
                    },
                    {
                        title: 'UTMSA - University of Toronto Mongolian Students Association',
                        image: 'https://images.prismic.io/vanmglcom/bef39b95-a27a-434e-ae79-f2cc982e609a_utmsa.png?auto=compress,format',
                        links: [
                            {
                                type: 'facebook',
                                url: 'https://www.facebook.com/uoftmongolia/community/'
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Communities.vue